// extracted by mini-css-extract-plugin
module.exports = {"choose":"Choose_choose__j8_S_"};